export const selectIsModalOpened = (state, name) => state.ui.modal[name].isOpen;

export default selectIsModalOpened;
